// src/Product.jsx

export default function Product() {
  return (
    <div>
      <h2>Tacos</h2>
	  <p>Price: 999 credits</p>
    </div>
  );
};